import React, { JSX } from 'react';
// import X from '../../icons/X';
// import Check from '../../icons/Check';

export interface ISelectData {
    label: string;
    value: string;
    disabled?: boolean;
}

export interface IFormInputData {
    classes?: string;
    overwriteClasses?: string;
    optionClasses?: string;
    overwriteOptionClasses?: string;
    selectClasses?: string;
    overwriteSelectClasses?: string;
    idx: string;
    label?: string;
    value: string;
    type: 'edit' | 'locked' | 'empty';
    options: ISelectData[];
    titleOrAction?: string | JSX.Element;
    onChange?: (newValue: string) => void;
}

const SelectInput = (props: IFormInputData) => {
    const { classes, overwriteClasses, optionClasses, overwriteOptionClasses, selectClasses, overwriteSelectClasses, titleOrAction, idx, label, value, options, type, onChange } = props;

    const [text, setText] = React.useState(value);
       
    React.useEffect(() => {
        setText(value);
    }, [idx, value])

    React.useEffect(() => {
        if (onChange) {
            onChange(text);
        }
    }, [text, value, onChange]);

    // console.log('SelectInput:', options);

    const innerParts = React.useMemo(() => {
        return (
            <div className={overwriteClasses ?? `relative self-stretch flex items-center border outline-1 border-border-default hover:border-blue-400 rounded-lg overflow-hidden transition-colors ${classes}`}>
                <select
                    id={`selectInput-${idx}`}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    disabled={type === 'locked'}
                    // onKeyDown={handleKeyDown}
                    className={overwriteSelectClasses ?? `flex-1 py-1.5 sm:py-2 px-4 ${type !== 'locked' ? 'pr-12' : ''} ${type === 'empty' ? 'bg-bg-input-empty' : ''} appearance-none focus:outline-none cursor-pointer ${selectClasses ?? 'bg-transparent'}`}
                >
                    {options.map(o => {
                        const parseLabel = (lbl: string) => {
                            const parts = lbl.split('|');
                            if (parts.length === 1) {
                                return lbl;
                            }
                            return (<>
                                <span className="text-left">{parts[0]}</span><div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div><span className="text-right">{parts[1]}</span>
                            </>);
                        };
                        return <option className="w-full" key={o.value} value={o.value} style={{ color: 'black' }} disabled={o.disabled}>{parseLabel(o.label)}</option>;
                    })}
                </select>

                {/* Dropdown arrow for select */}
                {/* {!hasChanged && ( */}
                {type !== 'locked' && 
                    <div className={overwriteOptionClasses ?? `absolute right-5 pointer-events-none ${optionClasses}`}>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                }
                {/* )} */}

                {/* Action buttons */}
            </div>
        );
    }, [classes, idx, options, optionClasses, overwriteClasses, overwriteOptionClasses, overwriteSelectClasses, selectClasses, text, type]);

    if (!label) {
        return innerParts;
    }

    return (
        <div className="self-stretch flex flex-col justify-center items-start gap-2 text-text-dark">
            <div className="sm:inline-flex sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 w-full">
                <div className="w-[50%] inline-flex self-stretch justify-start text-text-dark text-sm font-normal font-['Inter'] leading-tight">{label}</div>
                {titleOrAction && <div className="w-[50%] inline-flex self-stretch justify-end text-text-dark text-sm font-normal font-['Inter'] leading-tight">{titleOrAction}</div>}
            </div>
            {innerParts}
        </div>
    );
};

export default SelectInput;